// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Paperclip: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 46"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M9.3 45.4c-2.3 0-4.5-.9-6.1-2.5-3.8-3.8-3.4-9 .9-13.4L28.9 4.2C31.2 1.9 34.2.6 37.4.6s6.2 1.3 8.5 3.6c4.7 4.7 4.7 12.5 0 17.2l-21.6 22c-.5.5-1.4.5-1.9 0s-.5-1.4 0-1.9l21.6-22c3.6-3.7 3.6-9.7 0-13.3-1.7-1.8-4.1-2.8-6.5-2.8s-4.8 1-6.5 2.8L6.1 31.3c-3.3 3.3-3.6 6.8-.9 9.6 1.1 1.1 2.6 1.7 4.1 1.7 2 0 4-.9 5.6-2.5l19.9-20.3c1.2-1.2 1.2-3.1 0-4.3-1.1-1.1-3-1.1-4.1 0L14.1 32.4c-.5.5-1.4.6-1.9 0-.5-.5-.5-1.4 0-1.9l16.6-16.9c1.1-1.1 2.5-1.7 4-1.7s3 .6 4 1.7c2.2 2.2 2.2 5.9 0 8.1L16.9 42c-2.2 2.2-4.8 3.4-7.6 3.4z"/></svg>;
};

export default React.memo(Paperclip);
